import {OptionTypeBase} from 'platform/components';

import {isNil} from 'ramda';

import {BaseAuthorizationProfile} from '@dms/api/security';

import {Nullish} from 'shared/web';

type SelectedAuthorizationProfileIds = string | Nullish | (string | Nullish)[];

/**
 * Offers active profiles only; a deactivated profile stays listed, disabled, while it is selected,
 * so an existing assignment keeps rendering and survives a save. This narrows what is offered for
 * selection and enforces nothing — the API still accepts any profile id the tenant can read.
 */
export const getOptionsFromAuthorizationProfiles = (
  authorizationProfiles: BaseAuthorizationProfile[] | Nullish,
  selectedValue: SelectedAuthorizationProfileIds
): OptionTypeBase<string>[] => {
  if (isNil(authorizationProfiles)) {
    return [];
  }

  const selectedIds = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

  return authorizationProfiles
    .filter(
      (authorizationProfile) =>
        authorizationProfile.isActive || selectedIds.includes(authorizationProfile.id)
    )
    .map((authorizationProfile) => ({
      label: authorizationProfile.name,
      value: authorizationProfile.id,
      isDisabled: !authorizationProfile.isActive,
    }));
};
